module.exports = __webpack_public_path__ + "img/document-icon-white.2a3939d8.svg";